import React, { useState } from "react";
import { toast } from 'react-toastify';
import JsCodeEditor from "../../../components/JsCodeEditor";

const SettingTab = ({ handleLayoutChange, selectedLayout,updateTeamShowcaseTabData,teamShowcaseTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [messageTextType, setMessageTextType] = useState(teamShowcaseTabData.message_text_type);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(teamShowcaseTabData.custom_js);

    // Handlers Message Text Type Change
    const handlMessageTextTypeChange = (e) => {
        const value = e.target.value;
        setMessageTextType(value);
        updateTeamShowcaseTabData("message_text_type", value);
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updateTeamShowcaseTabData("custom_js", code);
    }; 

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => { 
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Settings</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label className="mb-1">Messages</label>
                            <input value={messageTextType} onChange={handlMessageTextTypeChange} placeholder="" type="text" />
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                        <p className="px-2 mt-0 pb-2">Adjust your bar's visibility for your website's pages and user devices. You can also set up a display schedule.</p>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_js" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom Js</span>
                        <div className="css-text height-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <div className="save-css-js"><button className="save-css-js" onClick={handleValidateClick}>Validate</button></div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default SettingTab;